// extracted by mini-css-extract-plugin
export default {"mainArticle":"IjLUt","wrapper":"uRy98"};